import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Automations", href: "#automations" },
    { label: "Industries", href: "#industries" },
    { label: "Pricing", href: "#pricing" },
    { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header className="fixed top-0 w-full z-50 bg-[#05070D]/80 backdrop-blur-xl border-b border-white/10" data-testid="navbar">
            <nav className="container-x flex items-center justify-between h-16 sm:h-20">
                <Link to="/" className="flex items-center gap-2.5" data-testid="navbar-brand">
                    <span className="w-8 h-8 rounded-xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center ff-display font-black text-sm text-white">
                        F
                    </span>
                    <span className="ff-display font-bold text-lg text-white tracking-tight">Flowtech</span>
                    <span className="hidden sm:inline-flex items-center gap-1.5 ml-2 ff-mono text-[9px] uppercase tracking-[0.15em] text-emerald-300 bg-emerald-400/10 border border-emerald-400/20 rounded-full px-2.5 py-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                        Agent Live
                    </span>
                </Link>
                <div className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm text-slate-400 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>
                <div className="flex items-center gap-3">
                    <a href="#book" data-testid="navbar-book-audit-button" className="hidden sm:inline-flex items-center rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition-[box-shadow,filter] duration-300 hover:brightness-110 shadow-[0_8px_24px_-10px_rgba(0,240,255,0.5)]">
                        Start a Chat Interview
                    </a>
                    <button
                        className="lg:hidden text-slate-300 p-2"
                        onClick={() => setOpen(!open)}
                        aria-label="Toggle menu"
                        data-testid="navbar-hamburger-button"
                    >
                        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </nav>
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="lg:hidden overflow-hidden border-t border-white/10 bg-[#05070D]/95 backdrop-blur-xl"
                        data-testid="navbar-mobile-menu"
                    >
                        <div className="container-x py-6 flex flex-col gap-1">
                            {LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    className="py-3 text-base text-slate-300 hover:text-cyan-300 transition-colors duration-300 border-b border-white/5"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a href="#book" onClick={() => setOpen(false)} className="btn-primary mt-4 justify-center">
                                Start a Chat Interview
                            </a>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
}
